import ExcelJS from 'exceljs';
import { EXPORT_ORDER, XLSX_COL_WIDTHS } from '../utils/utils';

const buildXlsxColumns = () =>
  EXPORT_ORDER.map(({ label }) => ({
    header: label,
    key: label,
    width: XLSX_COL_WIDTHS[label] || 18,
  }));

const styleHeader = ws => {
  const firstRow = ws.getRow(1);
  firstRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  firstRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF1462A5' },
  };
  firstRow.alignment = { vertical: 'middle', horizontal: 'left' };
};

const zebraRows = (ws, startRow = 2) => {
  for (let i = startRow; i <= ws.rowCount; i++) {
    if (i % 2 === 0) {
      ws.getRow(i).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF6FAFF' },
      };
    }
  }
};

const toExcelRows = (items = []) =>
  items.map(r => {
    const out = {};
    EXPORT_ORDER.forEach(({ key, label }) => {
      const v = r?.[key];
      if (key === 'createdAt' || key === 'updatedAt' || key === 'publishedAt') {
        out[label] = v ? new Date(v) : null;
      } else {
        out[label] = v ?? '';
      }
    });
    return out;
  });

const applyDateFormats = ws => {
  ['Criado em', 'Publicado em'].forEach(header => {
    ws.getColumn(header).numFmt = 'dd/mm/yyyy hh:mm';
  });
};

export async function downloadXlsx({ rows, filename = 'relatorio.xlsx' }) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Relatório');

  ws.columns = buildXlsxColumns();
  styleHeader(ws);
  ws.views = [{ state: 'frozen', ySplit: 1 }];

  const excelRows = toExcelRows(rows);
  ws.addRows(excelRows);
  applyDateFormats(ws);
  zebraRows(ws, 2);

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
